exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "td[data-v-bd1cb610]{word-break:break-all}.table thead th[data-v-bd1cb610]{vertical-align:top}", "", {"version":3,"sources":["F:/myugfront/src/components/exam-schedule/schedule-table.vue"],"names":[],"mappings":"AACA,oBACE,oBAAsB,CACvB,AACD,iCACE,kBAAoB,CACrB","file":"schedule-table.vue","sourcesContent":["\ntd[data-v-bd1cb610]{\n  word-break: break-all;\n}\n.table thead th[data-v-bd1cb610] {\n  vertical-align: top;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-bd1cb610","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exam-schedule/schedule-table.vue
// module id = 1004
// module chunks = 19